import React from "react"
import ReactDOM from "react-dom"

let PayPalButton = window.paypal
  ? paypal.Buttons.driver("react", {
      React,
      ReactDOM
    })
  : null;

class PaymentPayPalButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paypalData: {},
      loading: false
    };

    this.processPayPalPayment = this.processPayPalPayment.bind(this);
    this.createOrder = this.createOrder.bind(this);
    this.onApprove = this.onApprove.bind(this);
    this.onError = this.onError.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    // get paypal purchase details
    $.ajax({
      method: "GET",
      url: "/transactions/paypal/new",
      dataType: "json",
      success: data => {
        this.setState({
          paypalData: data.data
        });
      },
      error: e => {
        this.props.configGenericError({
          title: "Error",
          body: (
            <div>
              <p>Unfortunately something has gone wrong.</p>

              <p>
                We are sorry for any inconvenience this may cause. Please try
                again later. If the problem persists, please contact our
                customer service team.
              </p>
            </div>
          ),
          errorButton: true,
          errorButtonTitle: "Refresh Checkout",
          errorButtonAction: this.props.toggleGenericError,
          closeAction: this.props.toggleGenericError,
          reloadCheckoutAfterClose: true,
          reloadCheckoutAfterErrorButtonAction: true
        });
      }
    });
  }

  createOrder(data, actions) {
    this.processPayPalPayment();
    const paypalDetails = this.state.paypalData;
    return actions.order.create({
      purchase_units: paypalDetails.purchase_units,
      application_context: paypalDetails.application_context
    });
  }

  onApprove(data, actions) {
    this.setState({ loading: true });
    return actions.order.capture().then(function(details) {
      // send transaction details to backend to be processed

      $.ajax({
        url: "/transactions/paypal",
        dataType: "json",
        method: "POST",
        data: {
          orderID: data.orderID,
          payerID: data.payerID,
          token: details.id,
          status: details.status,
          transaction: details.purchase_units[0]
        },
        success: res => {
          location.href = decodeURIComponent(res.redirect_url);
        },
        error: (jqXHR, textStatus, errorThrown) => {
          var response = JSON.parse(jqXHR.responseText);
          var errors = [];
          if (response.errors) {
            errors = response.errors;
          }
        }
      });
    });
  }

  processPayPalPayment() {
    this.props.setPaymentStatus(true);
    this.setState({ loading: true });
  }

  onError(error, actions) {
    this.setState({
      loading: false,
      showPaypalError: true,
      paypalErrorMessage: 'Sorry there has been a problem with PayPal, your payment has not been taken.'
    });
  }

  onCancel(data, actions) {
    this.setState(
      {
        loading: false,
        showPaypalError: true,
        paypalErrorMessage:
          "You have canceled the PayPal payment. Please choose a different payment method."
      },
      () => {
        this.props.setPaymentStatus(false);
      }
    );
  }

  render() {
    var loading =
      this.state.loading === true ? (
        <div className="loader paypal">Loading....</div>
      ) : (
        ""
      );
    var showPaymentDisplayError = "";

    if (this.props.show_payment_display_error) {
      showPaymentDisplayError = (
        <div className="showPaymentDisplayError">
          {this.props.payment_display_errors.map((errorMessage, index) => (
            <p key={index}>{errorMessage}</p>
          ))}
        </div>
      );
    } else if (this.state.showPaypalError === true) {
      showPaymentDisplayError = (
        <div className="showPaymentDisplayError">
          <p>{this.state.paypalErrorMessage}</p>
        </div>
      );
    }
    return (
      <div className="checkout-sub-panel payment">
        {showPaymentDisplayError}
        {loading}
        <div className="paypal-payment-summary">
          <div className="paypal-warning">
            <p>
              <strong>You will be redirected to PayPal.</strong>
            </p>
            <div className="paypal-nav-away">
              <img
                src={this.props.assets.misc.paypalWarning}
                className="error-icon"
              />

              <div>
                <p className="main-warning">
                  Please{" "}
                  <strong>do not close the window or navigate away</strong> from
                  the page.
                </p>
                <p>This may cause multiple payments to be taken.</p>
              </div>
            </div>
          </div>
          <p>
            Your PayPal account will be charged:{" "}
            <strong>&pound;{this.props.paymentTotal}</strong> for your delivery
            items and delivery charge (if applicable).
          </p>
          <div className="paypal-pay-button">
            {/* TODO: setup purchase_units on the backend and pass as props. Get on componentDidMount  */}
            <PayPalButton
              style={{
                layout: "horizontal",
                color: "blue",

                tagline: false
              }}
              createOrder={(data, actions) => this.createOrder(data, actions)}
              onApprove={(data, actions) => this.onApprove(data, actions)}
              onError={(error, actions) => this.onError(error, actions)}
              onCancel={(data, actions) => this.onCancel(data, actions)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentPayPalButton;
